import { apiGet, apiPost, apiPut } from "../core/request";

const unwrap = <T>(r: any): T =>
  (r && typeof r === "object" && "data" in r ? r.data : r) as T;

export type KycDbStatus = "approved" | "pending" | "rejected";
export type KycUiStatus = KycDbStatus | "not_started";

export type KycRecord = {
  id: number;
  document_type: "passport" | "national_id" | "driving_license";
  document_country?: string | null;
  document_number: string;
  document_expiry: string;
  document_file?: string | null;
  document_back_file?: string | null;
  selfie_file?: string | null;
  poa_file?: string | null; // NEW: PoA path (if exposed)
  review_notes?: string | null;
  updated_at?: string;
  created_at?: string;
};

export type KycStatusPayload = {
  status: KycUiStatus;
  kyc: KycRecord | null;
  user: { id: number; first_name?: string | null; last_name?: string | null; email: string };
};

export type KycDocumentCountry = {
  code: string;
  label: string;
};

export type KycDocumentType = {
  code: KycRecord["document_type"];
  label: string;
  default_sides: "front_only" | "front_back";
};

export type KycDocumentOptionsPayload = {
  document_countries: KycDocumentCountry[];
  document_types: KycDocumentType[];
  default_profiles?: Record<string, any>;
};

export async function apiKycOptions(): Promise<KycDocumentOptionsPayload> {
  return unwrap(await apiGet("/xapi/kyc/options"));
}

export async function apiKycStatus(): Promise<KycStatusPayload> {
  return unwrap(await apiGet("/xapi/kyc/status"));
}

export async function apiKycSubmit(
  payload: Record<string, any> | FormData
): Promise<{ ok: boolean; id?: number; status?: KycUiStatus }> {
  return unwrap(await apiPost("/xapi/kyc", payload));
}

/** MUST be PUT to match your route list */
export async function apiKycUpdate(
  id: number | string,
  payload: Record<string, any> | FormData
): Promise<{ ok: boolean; status?: KycUiStatus }> {
  return unwrap(await apiPut(`/xapi/kyc/${id}`, payload));
}

/** Optional show */
export async function apiKycShow(id: number | string): Promise<KycRecord> {
  return unwrap(await apiGet(`/xapi/kyc/${id}`));
}
